import React, { useContext } from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/Seo"
import { I18nextContext, Link } from "gatsby-plugin-react-i18next"
import PortableText from "../components/PortableText"
import { GatsbyImage } from "gatsby-plugin-image"
import Contact from "../components/ContactButton"

const Services = ({ data }) => {
  const { language } = useContext(I18nextContext)
  const { blockOne, title, documentServices, blockThree } = data.sanityService
  return (
    <Layout>
      <Seo lang={language} title={title[language]} />
      <div className="max-w-screen-xl mx-auto">
        <div className="grid3">
          <div className="col-span-3 sm:col-span-1">
            <figure>
              <GatsbyImage
                image={
                  blockOne.thumbnail.asset?.localFile.childImageSharp
                    .gatsbyImageData
                }
                className="rounded"
                alt={blockOne.thumbnail.attribution || "Minä voin"}
              />
              {blockOne.thumbnail.caption !== null && (
                <figcaption className="text-gray-900 pt-2">
                  {blockOne.thumbnail.caption[language]}
                </figcaption>
              )}
            </figure>
          </div>
          <div className="col-span-3 sm:col-span-2">
            <h1>{blockOne.header[language]}</h1>
            <hr />
            <PortableText textData={blockOne._rawBody[language]} />
          </div>
        </div>
      </div>
      <div className="max-w-screen-2xl mx-auto bg-gray-50">
        <div className="max-w-screen-xl mx-auto bg-gray-50">
          <div className="p-10">
            <div className="text-center">
              <h1 className="items-center justify-center header text-2xl lg:text-3xl mb-0">
                {documentServices.header[language]}
              </h1>
            </div>
            <section className="flex flex-row flex-wrap mx-auto">
              {documentServices.serviceCards.map(serviceCard => {
                return (
                  <div
                    key={serviceCard._id}
                    className="transition-all duration-150 flex px-3 py-3 sm:w-1/2 md:w-1/2 lg:w-1/4"
                  >
                    <Link
                      to={`/services/${serviceCard.slug.current}`}
                      className="no-underline"
                    >
                      <div className="flex flex-col items-stretch min-h-full transition-all duration-150 bg-white rounded shadow hover:shadow-lg">
                        <div className="md:flex-shrink-0">
                          <GatsbyImage
                            loading="eager"
                            image={
                              serviceCard.image.asset.localFile.childImageSharp
                                .gatsbyImageData
                            }
                            className="rounded border-b-2 border-red-600"
                            alt={serviceCard.title[language] || "Minä voin"}
                          />
                          <section className="p-5 text-center">
                            <p className="text-base m-0">
                              {serviceCard.title[language]}
                            </p>
                          </section>
                        </div>
                      </div>
                    </Link>
                  </div>
                )
              })}
            </section>
          </div>
        </div>
      </div>
      <div className="max-w-screen-xl mx-auto">
        <div className="grid3">
          <div className="col-span-3 sm:col-span-2">
            <h1>{blockThree.header[language]}</h1>
            <hr />
            <PortableText textData={blockThree._rawBody[language]} />
            <Contact />
          </div>
          <div className="col-span-3 sm:col-span-1">
            <figure>
              <GatsbyImage
                image={
                  blockThree.thumbnail.asset?.localFile.childImageSharp
                    .gatsbyImageData
                }
                className="rounded"
                alt={blockThree.thumbnail.attribution || "Minä voin"}
              />
              {blockThree.thumbnail.caption !== null && (
                <figcaption className="text-gray-900 pt-2">
                  {blockThree.thumbnail.caption[language]}
                </figcaption>
              )}
            </figure>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    sanityService {
      documentServices {
        header {
          en
          fi
        }
        serviceCards {
          ... on SanityServices {
            title {
              fi
              en
            }
            _id
            image {
              asset {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 400
                      aspectRatio: 1.5
                      formats: [AUTO, WEBP, AVIF]
                    )
                  }
                }
              }
            }
            slug {
              current
            }
          }
        }
      }
      title {
        en
        fi
      }
      blockThree {
        _rawBody(resolveReferences: { maxDepth: 10 })
        header {
          en
          fi
        }
        thumbnail {
          asset {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          attribution
          caption {
            en
            fi
          }
        }
      }
      blockOne {
        header {
          en
          fi
        }
        thumbnail {
          asset {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          attribution
          caption {
            en
            fi
          }
        }
        _rawBody(resolveReferences: { maxDepth: 10 })
      }
    }
  }
`
export default Services
